import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const GET_BOOKING_EVENT_QUERY = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  query getBookingEvent($id: String!) {
    getEvent(id: $id, includeDraft: false, includeDeactivated: false) {
      ... on GetEventOutput {
        event {
          id
          name
          dateStart
          startDateDescription
          startTime
          startTimeDescription
          spotsRemaining
          memberDiscount
          gstExempt
          admissions {
            id
            price
            admissionType {
              ... on GetAdmissionTypeOutput {
                admissionType {
                  id
                  name
                  position
                  attendees
                }
              }
              ...UnauthenticatedError
              ...UnauthorizedError
              ...ServerError
            }
          }
          eventCustomAttendeeFields {
            id
            position
            customAttendeeField {
              ... on GetCustomAttendeeFieldOutput {
                customAttendeeField {
                  id
                  label
                  type
                  required
                }
              }
            }
          }
          club {
            ... on GetClubOutput {
              club {
                id
                clubName
                slug
                addressLine1
                addressLine2
              }
            }
            ...UnauthenticatedError
            ...UnauthorizedError
            ...ServerError
          }
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
